import { MILLISECONDS_IN_DAY } from "owa-date-constants";

export default (timestamp: number | Date, days: number): Date => new Date(+timestamp + days * MILLISECONDS_IN_DAY);
